'use strict';

/**
 *
 * @name: apiUtilityService
 *
 */

function apiUtilityService($rootScope, $http) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function getAwards() {

    var target = $rootScope.apiUrlNew + '/award';

    return $http.get(target);
  }

  function getPage(key) {

    var target = $rootScope.apiUrlNew + '/page/getbykey/' + key;

    return $http.get(target);
  }

  function getTopics() {

    var target = $rootScope.apiUrlBak + '/topic?topicType=contact';

    return $http.get(target);
  }

  /**
   *
   * @PRIVATE
   *
   */

  return {

    getAwards: getAwards,
    getPage: getPage,
    getTopics: getTopics,
  };
}

export default apiUtilityService;



// WEBPACK FOOTER //
// ./app/components/_api/utility.service.js